import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class HttpVersionInterceptorService implements HttpInterceptor {
   // eslint-disable-next-line no-useless-constructor
   constructor(private version: string) {}

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      req = req.clone({ setHeaders: { version: this.version } });
      return next.handle(req);
   }
}
